import styled, { css } from 'styled-components';
import TextFieldProps from './type';

const commonTypographyStyles = css<TextFieldProps>`
  ${({ theme }) => theme.typography.bodyMedium3};
`;

export const TextFieldWrapperStyled = styled.div<TextFieldProps>`
  display: flex;
  flex-direction: column;
  gap: 9px;
  position: relative;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '325px')};
  @media (max-width: 280px) {
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '196px')};
  }
  &:focus-within {
    p {
      ${({ disabled, theme }) => !disabled && `color: ${theme.colors.blue500}`};
    }
  }
`;

export const TextFieldLabelWrapperStyled = styled.div<TextFieldProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${commonTypographyStyles};
  color: ${({ theme: { colors }, disabled }) => (disabled ? colors.gray500 : colors.gray700)};
`;

export const TextFieldMessageStyled = styled.div<TextFieldProps>`
  display: flex;
  gap: 5px;
  align-items: center;
  ${commonTypographyStyles};
  color: ${({ theme: { colors }, helperType, disabled }) => {
    if (disabled) return colors.gray500;
    switch (helperType) {
      case 'error':
        return '#F65940';
      case 'warning':
        return '#FBC832';
      case 'success':
        return `${colors.green500}`;
      default:
        return colors.gray700;
    }
  }};
`;

export const ContentStyled = styled.div<TextFieldProps>`
  display: grid;
  grid-template-rows: 1fr;
  height: 50px;
  padding-inline: 20px;
  align-items: center;
  gap: 20px;
  border-radius: 4px;
  background: #e3edf7;
  position: relative;

  grid-template-columns: ${({ startAdornment, endAdornment }) => {
    return `${startAdornment ? 'auto' : ''} 1fr ${endAdornment ? 'auto' : ''}`;
  }};

  box-shadow: ${({ disabled, value }) =>
    disabled || value
      ? '4px 4px 20px 0px rgba(111, 140, 176, 0.41), 2px 2px 4px 0px rgba(114, 142, 171, 0.10);'
      : '  4px 4px 14px 0px #c5d7ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.6) inset;'};

  ${({ theme: { colors }, helperText, helperType, disabled }) => {
    if (disabled) return `border: 1px solid ${colors.gray400}`;
    if (!helperText) return 'border: 0px';
    switch (helperType) {
      case 'error':
        return 'border: 1px solid #F65940';
      case 'warning':
        return 'border: 1px solid #FBC832';
      case 'success':
        return `border: 1px solid ${colors.green500}`;
      case 'disabled':
        return `border: 1px solid ${colors.gray400}`;
      default:
        return 'border: 0px';
    }
  }};

  ::before {
    content: '';
    position: absolute;
    border-radius: 5px;
    top: -1px;
    left: -2px;
    right: -1px;
    bottom: -2px;
    z-index: -1;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 50%, rgba(214, 227, 243, 0.46) 100%);
  }
`;

export const TextFieldStyled = styled.input<TextFieldProps>`
  flex-shrink: 0;
  border: 0;
  width: 100%;
  background: transparent;
  ${({ theme }) => theme.typography.body3};
  color: ${({ theme, disabled }) => (disabled ? theme.colors.gray500 : theme.colors.gray700)};

  ::placeholder {
    color: ${({ theme, disabled }) => (disabled ? theme.colors.gray500 : theme.colors.gray700)};
    ${({ theme }) => theme.typography.body3};
  }

  ${({ disabled, theme }) =>
    !disabled &&
    `
  :focus {
    outline: none;
    color: ${theme.colors.blue500};
    ::placeholder {
      color: ${theme.colors.blue500};
    }
  }`};

  :not([value='']) {
    color: ${({ theme, disabled }) => (disabled ? theme.colors.gray800 : theme.colors.blue500)};
  }
`;
